import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _InfoRoundLight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("circle", { cx: 12, cy: 12, r: 9, stroke: "currentColor" }),
            React.createElement("path", { fill: "currentColor", d: "M12.5 7.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0" }),
            React.createElement("path", { stroke: "currentColor", d: "M12 17v-7" })));
}
const InfoRoundLight = forwardRef(_InfoRoundLight);
export { InfoRoundLight };
